export const usage = {
  title: "Detalhes de Uso",
  subtitle: "Acompanhe seu uso de tokens e custos",
  table: {
    date: "Data",
    model: "Modelo",
    promptTokens: "Tokens de Entrada",
    completionTokens: "Tokens de Saída",
    inputCost: "Custo de Entrada",
    outputCost: "Custo de Saída",
    totalCost: "Custo Total",
  },
  stats: {
    subscription: {
      plan: "Plano",
      credits: "Créditos Disponíveis",
      totalSpent: "Total Gasto",
      status: "Status",
      nextBilling: "Próxima Cobrança",
    },
    total: {
      title: "Uso Total",
      tokens: "Total de Tokens",
      cost: "Custo Total",
    },
    byModel: {
      title: "Uso por Modelo",
      model: "Modelo",
      inputTokens: "Tokens de Entrada",
      outputTokens: "Tokens de Saída",
      inputCost: "Custo de Entrada",
      outputCost: "Custo de Saída",
      totalCost: "Custo Total",
      inputOutputTokens: "Input / Output Tokens",
    },
    recent: {
      title: "Uso Recente",
      noTransactions: "Nenhuma transação recente",
    },
  },
  noData: "Nenhum dado de uso disponível",
  loading: "Carregando dados de uso...",
  error: "Erro ao carregar dados de uso",
  refresh: "Atualizar Dados",
};
